import type { PricingMode } from "../../../lib/agent-types";

export function pricingModeForLoanProduct(
  product?: string | null,
): PricingMode {
  switch (product) {
    case "fha":
    case "va":
    case "usda":
      return "program_fee";
    case "jumbo":
      return "lender_grid";
    default:
      return "conventional_llpa";
  }
}

export function pricingModeNoteForMode(mode?: PricingMode | null) {
  switch (mode) {
    case "program_fee":
      return "FHA, VA, and USDA loans price off a program fee schedule — your rate sits on the agency's published rate, with an upfront and/or monthly program fee added separately rather than an LLPA grid.";
    case "lender_grid":
      return "Jumbo loans price off lender-specific grids rather than the agency LLPA matrix. Real quotes vary materially across lenders — ask a lender directly.";
    default:
      return "";
  }
}
